import head from 'lodash/head'
import last from 'lodash/last'
import toUpper from 'lodash/toUpper'
import words from 'lodash/words'

export function getInitials(name?: string | null): string {
	const parts = words(name ?? '')
	if (!parts.length) {
		return ''
	}

	const first = head(parts)?.charAt(0) ?? ''
	const lastLetter = parts.length > 1 ? last(parts)?.charAt(0) ?? '' : ''
	return toUpper(`${first}${lastLetter}`)
}
